import React from "react"
import { Typography, TypographyProps } from "@mui/material"

type Props = TypographyProps & {
  children: React.ReactNode
}

const ModalTitleComponent = ({ children }: Props) => {
  return (
    <Typography align="center" variant="h6">
      {children}
    </Typography>
  )
}

export default ModalTitleComponent
